import config from "config";
import { ContentLayoutType3 } from "pages/Product/ContentLayouts/ContentLayoutType3";
import {
  AssetArea,
  DescriptionArea1,
  DescriptionArea2,
  DescriptionContent,
  DescriptionTitle,
  Image,
  SectionSubTitle,
  SectionTitle,
  TitleArea,
} from "pages/Product/ContentLayouts/styled";
import { FeatureSectionWrapper } from "pages/Product/FeaturesSection/styled";
import React from "react";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";

const StyledContentLayoutType3 = styled(ContentLayoutType3)`
  ${AssetArea} {
    padding: 10px 0 30px 0;
  }

  ${mediaMin.xs`
    ${AssetArea} {
      padding: 60px 0;
    }
  `};

  ${mediaMin.md`
    ${AssetArea} {
      padding: 0;
    }
  `};
`;

export function Meeting() {
  return (
    <FeatureSectionWrapper id="meetings">
      <StyledContentLayoutType3>
        <TitleArea>
          <SectionSubTitle>How can I manage</SectionSubTitle>
          <SectionTitle>Meetings?</SectionTitle>
        </TitleArea>
        <DescriptionArea1>
          <DescriptionTitle>Opt-in Scheduling</DescriptionTitle>
          <DescriptionContent>
            Clients will book a meeting via your scheduling page. You can
            approve or arrange the schedule.
          </DescriptionContent>
        </DescriptionArea1>
        <DescriptionArea2>
          <DescriptionTitle>Pre-built Meeting Notes</DescriptionTitle>
          <DescriptionContent>
            You can take advantage of templates according to use cases and
            powerful formatting options.
          </DescriptionContent>
        </DescriptionArea2>
        <AssetArea>
          <Image
            src={`${config.RESOURCE_ORIGIN}/images/landing/product/feature-meeting.png`}
          />
        </AssetArea>
      </StyledContentLayoutType3>
    </FeatureSectionWrapper>
  );
}
